import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('RDE-Kategorien')
    .setRoute('rde_category_list')
    .setAdditionalRoutes([
        'rde_category',
    ]);
